
import React from "react";
import "./App.css";
import { Box } from "@chakra-ui/react";
import AllRoutes from "./Components/AllRoutes";


function App() {
  return (
    <Box>
      <AllRoutes />
    </Box>
  );
}

export default App;
